import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, hasRole } from './lib/auth.jsx';
import Login from './pages/Login.jsx';
import { AppShell } from './components/AppShell.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Clients from './pages/Clients.jsx';
import Articles from './pages/Articles.jsx';
import Categories from './pages/Categories.jsx';
import Company from './pages/Company.jsx';
import Series from './pages/Series.jsx';
import Vat from './pages/Vat.jsx';
import Currencies from './pages/Currencies.jsx';
import Users from './pages/Users.jsx';
import Documents from './pages/Documents.jsx';
import DocumentBuilder from './pages/DocumentBuilder.jsx';
import DocumentView from './pages/DocumentView.jsx';
import Payments from './pages/Payments.jsx';
import Recurring from './pages/Recurring.jsx';
import Reports from './pages/Reports.jsx';
import Audit from './pages/Audit.jsx';
import EmailSettings from './pages/EmailSettings.jsx';
import PublicView from './pages/PublicView.jsx';
import Expenses from './pages/Expenses.jsx';
import ImportPage from './pages/Import.jsx';
import Placeholder from './pages/Placeholder.jsx';

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!hasRole(user, 'ADMIN')) return <Placeholder title="Forbidden" note="Admins only." />;
  return children;
}

export default function App() {
  const { user, loading } = useAuth();
  // Public route works with or without auth
  if (loading) return <div className="auth-shell"><span className="spinner" /></div>;
  return (
    <Routes>
      <Route path="/p/:token" element={<PublicView />} />
      <Route path="*" element={user ? <AuthedApp /> : <Login />} />
    </Routes>
  );
}

function AuthedApp() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/invoices" element={<Documents type="INVOICE" />} />
        <Route path="/quotes" element={<Documents type="QUOTE" />} />
        <Route path="/proformas" element={<Documents type="PROFORMA" />} />
        <Route path="/credit-notes" element={<Documents type="CREDIT_NOTE" />} />
        <Route path="/documents/new" element={<DocumentBuilder />} />
        <Route path="/documents/:id" element={<DocumentView />} />
        <Route path="/documents/:id/edit" element={<DocumentBuilder />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/recurring" element={<Recurring />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings/company" element={<AdminOnly><Company /></AdminOnly>} />
        <Route path="/settings/series" element={<AdminOnly><Series /></AdminOnly>} />
        <Route path="/settings/vat" element={<AdminOnly><Vat /></AdminOnly>} />
        <Route path="/settings/currencies" element={<AdminOnly><Currencies /></AdminOnly>} />
        <Route path="/settings/users" element={<AdminOnly><Users /></AdminOnly>} />
        <Route path="/settings/email" element={<AdminOnly><EmailSettings /></AdminOnly>} />
        <Route path="/settings/audit" element={<AdminOnly><Audit /></AdminOnly>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
